import { withSentryReactRouterV7Routing } from "@sentry/react";
import View from "./views/view";
import { Routes, Route } from "react-router";
import { createContext } from "react";
import { translate } from "./locales";

export const SentryRoutes = withSentryReactRouterV7Routing(Routes);
export const LocaleContext = createContext({});

export default function App({ locale }) {
  function translateWithLocale(key, interpolations, specifiedLocale = locale) {
    return translate(key, interpolations, specifiedLocale);
  }

  return (
    <LocaleContext value={{ locale, translate: translateWithLocale }}>
      <SentryRoutes>
        <Route path="/" element={<View />} />
      </SentryRoutes>
    </LocaleContext>
  );
}
